/* eslint-disable import/no-cycle */
import _ from 'lodash';
import { 
	openTopic,
	closeTopic,
	resetTopic,
	destroyTopic,

	pushMessage,
	pushMessages,
	updateMessage,
	deleteMessage,

	clearAll,

	// unique message type functionality
	removeAllInitializingMonitorMessages,
} from './actions';

import { ROOT_SLICE } from './constants';
import { initialState } from './initialState';
import {
	selectThisSlice,
	selectMessagesByTopicMap,
} from './selectors';

import UTIL from './util/state';
import UTIL_MSG_INITIALIZING_MONITOR from './util/message.initializingmonitor';

const isDefined = v => v !== undefined && v !== null;

// ************
// PARTS
// ************
const reducerParts = {
	[clearAll]: state => {
		return {
			...state,
			[ROOT_SLICE]: _.cloneDeep(initialState)
		};
	},


	// ************
	// TOPIC REDUCERS
	// ************

	[openTopic]: (state, { payload: { topic } }) => {
    	const rootSlice = selectThisSlice(state);
		const messagesByTopic = selectMessagesByTopicMap(state);
		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
				messagesByTopic: UTIL.openTopic(messagesByTopic, { topic }),
			}
		};
	},

	[closeTopic]: (state, { payload: { topic } }) => {
    	const rootSlice = selectThisSlice(state);
		const messagesByTopic = selectMessagesByTopicMap(state);
		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
				messagesByTopic: UTIL.closeTopic(messagesByTopic, { topic }),
			}
		};
	},

	[resetTopic]: (state, { payload: { topic } }) => {
    	const rootSlice = selectThisSlice(state);
		const messagesByTopic = selectMessagesByTopicMap(state);
		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
				messagesByTopic: UTIL.resetTopic(messagesByTopic, { topic }),
			}
		};
	},

	[destroyTopic]: (state, { payload: { topic } }) => {
    	const rootSlice = selectThisSlice(state);
		const messagesByTopic = selectMessagesByTopicMap(state);
		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
				messagesByTopic: UTIL.destroyTopic(messagesByTopic, { topic }),
			}
		};
	},



	// ************
	// MESSAGE REDUCERS
	// ************

	[pushMessage]: (state, { payload: { topic, message } }) => {
    	const rootSlice = selectThisSlice(state);
		const messagesByTopic = selectMessagesByTopicMap(state);
		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
				messagesByTopic: UTIL.pushMessage(messagesByTopic, { topic, message }),
			}
		};
	  },

	[pushMessages]: (state, { payload: { topic, messages } }) => {
    	const rootSlice = selectThisSlice(state);
		const messagesByTopic = selectMessagesByTopicMap(state);
		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
				messagesByTopic: UTIL.pushMessages(messagesByTopic, { topic, messages }),
			}
		};
	  },

	[updateMessage]: (state, { payload: { topic, message } }) => {
    	const rootSlice = selectThisSlice(state);
		const messagesByTopic = selectMessagesByTopicMap(state);
		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
				messagesByTopic: UTIL.updateMessage(messagesByTopic, { topic, message }),
			}
		};
	  },

	[deleteMessage]: (state, { payload: { topic, message } }) => {
    	const rootSlice = selectThisSlice(state);
		const messagesByTopic = selectMessagesByTopicMap(state);
		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
				messagesByTopic: UTIL.deleteMessage(messagesByTopic, { topic, message }),
			}
		};
	  },



	// ************
	// UNIQUE MESSAGE TYPE FUNCTIONALITY
	// ************

	[removeAllInitializingMonitorMessages]: (state, { payload: { topic } }) => {
    	const rootSlice = selectThisSlice(state);
		const messagesByTopic = selectMessagesByTopicMap(state);
		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
				messagesByTopic: UTIL_MSG_INITIALIZING_MONITOR.removeAllMessages(messagesByTopic, { topic }),
			}
		};
	  },

  };

export default reducerParts;
